import CustomSearchBox from './CustomSearchBox'

export default CustomSearchBox
